<template>
  <div class="login container-fluid">
    <div class="row">
      <div class="col-md-6 offset-md-3">
        <template v-if="isError">
          <div class="alert alert-error">
            <h6>One or more fields were blank</h6>
          </div>
        </template>
        <h3>Sign Up</h3>
        <label class="form-label">Email</label>
        <input class="form-control" type="text" v-model="email" placeholder="Email"><br />
        <label class="form-label">Password</label>
        <input class="form-control" type="password" v-model="password" placeholder="*******"><br />
        <div class="text-center">
          <button class="btn btn-primary" @click="login">Sign Up</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import firebase from 'firebase';

  export default {
    name: 'signup',
    props: {
      path: {
        type: String,
        default: '/'
      },
      messaging: {
        type: String,
        default: '',
      }
    },
    data() {
      return {
        email: '',
        password: '',
        accesskey: '',
        username: '',
        isError: false,
      }
    },
    methods: {
      login: function() {
        if(this.email === '' || this.password === '') {
          this.isError = true;
          return;
        }
        firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(
          (user) => {
            console.log('successful login');
            mixpanel.identify(user.user.uid)
            this.$router.push({ path: '/' })
          },
          (err) => {
            alert('Oops. ' + err.message)
          }
        );
        mixpanel.track("click", {"name": "sign up button"})
      }
    }
  }
</script>

<style>
.form-label {
  text-align: left;
}
</style>